module.exports = __webpack_public_path__ + "static/media/2.8cf8d7c3.jpg";